import dayjs from 'dayjs';

/**
 * FileUploadDialogNoGrid와 동일: PreviewFiles 경로 정규화
 */
export const normalizePreviewFilePath = (raw) => {
  if (!raw || typeof raw !== 'string') return '';

  const s = raw.replace(/\\/g, '/');

  const idx = s.indexOf('PreviewFiles/');
  if (idx !== -1) return s.substring(idx);

  const idx2 = s.indexOf('PreviewFiles');
  if (idx2 !== -1) {
    return s.substring(idx2).replace(/^PreviewFiles$/, 'PreviewFiles/');
  }

  const marker = '/files/';
  const urlIdx = s.indexOf(marker);
  if (urlIdx !== -1) {
    const tail = s.substring(urlIdx + marker.length);
    try {
      return decodeURIComponent(tail);
    } catch {
      return tail;
    }
  }

  return raw;
};

/**
 * FileUploadDialogNoGrid.handleFileChange와 동일하게 업로드용 File 객체 생성
 * @returns {{ fileToSave: File, saveName: string, displayName: string }}
 */
export const buildUploadFileLikeDialog = (file) => {
  const displayName = file?.name ?? '';
  const timestamp = dayjs().format('YYYYMMDDHHmmss');
  const saveName = `${timestamp}_${displayName}`;
  const fileToSave = new File([file], saveName, {
    type: file.type || 'application/octet-stream',
  });
  return { fileToSave, saveName, displayName };
};
